import { render, staticRenderFns } from "./ZGRBUYUS.vue?vue&type=template&id=4c9d594e&scoped=true&"
import script from "./ZGRBUYUS.vue?vue&type=script&lang=js&"
export * from "./ZGRBUYUS.vue?vue&type=script&lang=js&"
import style0 from "./ZGRBUYUS.vue?vue&type=style&index=0&id=4c9d594e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9d594e",
  null
  
)

export default component.exports